const Home = () => {
  return (
    <>
      <div className="home-container">
        <div className="portada">
          <div className="portada-box-1">
            <h3>Bienvenido a</h3>
            <h1>Tecno Tienda</h1>
            <p>Tienda de computación y tecnología</p>
          </div>
          <div className="portada-box-2">
            <img
              src="https://i.ibb.co/7bRCXRt/Nice-Png-ecommerce-development-png-2559542-copia.webp"
              alt=""
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;
